import { Button, Col, Input, Modal, Row, Space, Table, Tooltip, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { cloneVariant, deactiveVariant, deleteVariant, viewVariant } from '../../../api/AdminRequest';
import { ArrowLeftOutlined, ExclamationCircleFilled, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { FaClone, FaEdit, FaEye } from 'react-icons/fa';
import { CgBlock, CgUnblock } from 'react-icons/cg';
import { MdDelete } from 'react-icons/md';
import Highlighter from 'react-highlight-words';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VariantDrawer from '../../drawer/VariantDrawer';
import AddVariants from '../productModifier/AddVariants';
const { Title } = Typography;
const { confirm } = Modal;

function ViewVariants() {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const [variants, setVariants] = useState('')
    const [loader, setLoader] = useState(true)
    const [change, setChange] = useState('')
    const [viewId, setViewID] = useState('')
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { state } = useLocation();

    const from = state?.from?.pathname

    const productID = state?.id

    // console.log(state, 'qwertyuiop');

    useEffect(() => {
        const getVariants = async () => {
            try {

                const { data } = await viewVariant(state.id)
                // console.log(data, '12355');
                setVariants(data.variants)
                setLoader(false)
            } catch (error) {
                // console.log(error.message);
            }
        }
        getVariants()
    }, [change])

    const showDrawer = async (ID) => {
        setViewID(ID)
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    // const handleEdit = (id) => {
    //     // navigate("/update-product", { state: id });
    // }
    const handleDeactive = async (id) => {

        try {
            setLoader(true)
            const { data } = await deactiveVariant(id);
            // console.log(data);
            if (data.block) {
                // console.log("sucess blocked");
                // setCardStatus("blocked")
                setLoader(false)
            }
            if (data.active) {
                // setCardStatus("active")
                setLoader(false)
            }
            setChange(Date.now())
        } catch (error) {
            console.log(error);
            toast(error.response.data.message);
        }
    };

    const handleDelete = async (id) => {
        try {
            setLoader(true)
            const { data } = await deleteVariant(id);
            // console.log(data);
            if (data.delete) {
                // console.log("sucess delete");
                setChange(Date.now())
                setLoader(false)
            }
        } catch (error) {
            console.log(error);
        }
    };
    const showDeactiveConfirm = (data) => {
        confirm({

            title: `${data?.status === 'active' ? 'Are you sure to Block ' : 'Are you sure to Active'}`,
            icon: <ExclamationCircleFilled />,
            content: `${data?.status === 'active' ? 'if you block, the variant cannot view any more ' : 'if you activate, all can view the variant.'}`,
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onOk() {
                handleDeactive(data._id);
                // { cardStatus === "active" ? setCardStatus("deactive") : setCardStatus("active") }
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    }
    const showDeleteConfirm = (data) => {
        confirm({
            title: "Are you sure delete?",
            icon: <ExclamationCircleFilled />,
            // content: `${admin ? 'if you delete the card the user also get deleted.' : ' }` ,
            content: `if you delete, the variant will deleted`,
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onOk() {
                handleDelete(data._id);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    }


    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        className='bg-blue-800'
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    {/* <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button> */}
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            clearFilters && handleReset(clearFilters)
                            handleSearch(selectedKeys, confirm)
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const variantsButton = <p className='add-button rounded-lg ml-auto' ><PlusOutlined />Add Variant</p>
    const variantsButtonEdit = <Tooltip title="edit"><FaEdit size={20} className='cursor-pointer' /></Tooltip>

    const showCloneConfirm = (data) => {
        confirm({
            title: "Are you sure to clone ?",
            icon: <ExclamationCircleFilled />,
            // content: `${admin ? 'if you delete the card the user also get deleted.' : ' }` ,
            content: `You really want to clone this variant, if you clone the variant will dupliacted`,
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onOk() {
                handleClone(data._id);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    }
    const handleClone = async (id) => {
        try {
            setLoader(true)
            const { data } = await cloneVariant(id)
            console.log(data);
            if (data.success) {
                // console.log("sucess delete");
                setChange(Date.now())
                setLoader(false)
                toast.success('Variant Cloned Successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "dark",
                });
            }
        } catch (error) {
            console.log(error);
            setLoader(false)
        }
    }

    const columns = [
        {
            title: 'No.',
            dataIndex: '_id',
            key: 'index',
            // render: (text, record, index) => index + 1,
            render: (text, record, index) => (variants.indexOf(record) + 1),
        },
        {
            title: 'Variant Name',
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name'),
        },
        {
            title: 'Subtittle',
            dataIndex: 'subtittle',
            key: 'subtittle',
            ...getColumnSearchProps('subtittle'),
        },

        {
            title: 'Availability',
            dataIndex: 'availability',
            key: 'availability',
            render: (availability) => { return availability ? <p className=' text-center'>Available</p> : <p className='bg-red-500 px-1 text-white text-center rounded-xl'>Not-Available</p> },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            // ...getColumnSearchProps('status'),
            render: (status) => { return status === 'active' ? <p className=' text-center'>Active</p> : <p className='bg-red-500 px-1 text-white text-center rounded-xl'>Blocked</p> },
        },
        {
            title: 'Action',
            dataIndex: 'status._id',
            key: '_id',
            render: (status, _id) => {
                return (
                    <>
                        <div className='flex gap-3 items-center'>
                            <Tooltip title="view"><FaEye size={20} className='cursor-pointer' onClick={() => showDrawer(_id)} /></Tooltip>
                            {/* <Tooltip title="edit"><FaEdit size={20} className='cursor-pointer' onClick={() => handleEdit(_id)} /></Tooltip> */}

                            <AddVariants variantsButton={variantsButtonEdit} Id={_id._id} setChange={setChange} edit={'edit'} detail={_id} />

                            {_id.status === 'active' ?
                                <Tooltip title="block"><CgBlock size={28} className='cursor-pointer' onClick={() => showDeactiveConfirm(_id)} /></Tooltip>
                                :
                                <Tooltip title="unblock"> <CgUnblock size={20} className='cursor-pointer' onClick={() => showDeactiveConfirm(_id)} /></Tooltip>
                            }
                            <Tooltip title="delete"><MdDelete size={20} className='cursor-pointer' onClick={() => showDeleteConfirm(_id)} /></Tooltip>
                            <Tooltip title="Clone"><FaClone size={20} className='cursor-pointer' onClick={() => showCloneConfirm(_id)} /></Tooltip>
                        </div>
                    </>
                )
            }

        },

    ];

    const handelBack = () => {
        navigate(from ? from : '/view-products', { replace: true })
    }





    return (
        <div>
            <Row gutter={16}>
                <Col span={12} className='flex'>
                    <p className='text-md  mr-5 h-12  pt-2 px-3 rounded-full border  font-medium cursor-pointer' onClick={handelBack}> <ArrowLeftOutlined className='text-xl' /> </p>
                    <Title level={2}>Variants </Title>
                </Col>
                <Col span={12} className='text-right'>
                    {/* {state?.id ? */}
                    <AddVariants variantsButton={variantsButton} Id={productID} setChange={setChange} />
                    {/* : ''} */}
                </Col>
            </Row>

            <div className='flex justify-center'>
                <div className='w-full mt-5'>
                    <Table columns={columns} loading={loader} dataSource={variants} pagination={variants.length > 10 ? true : false} />
                    <VariantDrawer viewId={viewId} setChange={setChange} open={open} onClose={onClose} />


                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default ViewVariants